var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-collapse",
    { attrs: { title: "Dados do Título" } },
    [
      _c(
        "el-row",
        { staticClass: "labelDiv" },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome do beneficiário:",
                  content: _vm.getValue(_vm.imovel.nomeBeneficiarioTitulo)
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "N° do Título:",
                  content: _vm.getValue(_vm.imovel.numeroTitulo)
                }
              }),
              _c("app-display", {
                attrs: {
                  label: " Município:",
                  content: _vm.getMunicipio(_vm.imovel.municipioTitulo)
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: { label: "Área:", content: _vm.area }
              }),
              _c("app-display", {
                attrs: { label: "Data de expedição:", content: _vm.data }
              }),
              _c("app-display", {
                attrs: {
                  label: _vm.labelsCadastro.imovel.lote,
                  content: _vm.imovel.numeroLote
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dcb6486", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dcb6486","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/common/InfoDadosTitulo.vue
// module id = null
// module chunks = 